// extracted by mini-css-extract-plugin
module.exports = {"toggleRow":"CategoryToggle_toggleRow__38gFJ","toggleButton":"CategoryToggle_toggleButton__1aEdR","active":"CategoryToggle_active__2zci_"};